import React from "react";
import { validateJson } from "../utils/validateJson";
import * as xmljs from "xml-js";
import DualEditorConvert from "../components/DualEditorConvert";
import AdSenseAd from "../components/AdSenseAd";

const convertJsonToXml = (input) => {
  const result = validateJson(input);
  if (!result.valid) throw new Error(result.message);

  const jsonObj = JSON.parse(input);
  return '<?xml version="1.0" encoding="UTF-8"?>\n' +
         xmljs.js2xml(jsonObj, { compact: true, spaces: 2 });
};

const JsonToXml = () => {
  return (
   <div className="max-w-7xl mx-auto px-4 py-6">
  <h1 className="text-4xl font-bold text-center bg-gradient-to-r from-blue-600 to-indigo-600 text-transparent bg-clip-text mb-2">
    JSON to XML Converter
  </h1>
  <DualEditorConvert
        inputLang="json"
        outputLang="xml"
        convertFn={convertJsonToXml}
      />
  <section className="text-gray-700 dark:text-gray-300 text-center max-w-2xl mx-auto mb-6">
    <p className="mb-3">
      Easily convert your JSON data into XML format for use in legacy systems, data migration, and XML-based APIs. This tool works entirely in your browser—no data is sent to any server, ensuring privacy and security.
    </p>
    <h2 className="text-xl font-semibold mt-6 mb-2">Why convert JSON to XML?</h2>
    <ul className="list-disc list-inside text-left mb-3">
      <li>Integrate with enterprise or legacy systems that require XML input.</li>
      <li>Prepare data for XML-based APIs, web services, or configuration files.</li>
      <li>Facilitate data migration between modern and older platforms.</li>
    </ul>
    <h2 className="text-xl font-semibold mt-6 mb-2">How to use this tool:</h2>
    <ol className="list-decimal list-inside text-left mb-3">
      <li>Paste or type your JSON data into the left editor.</li>
      <li>Click the <b>Convert</b> button.</li>
      <li>Copy the generated XML from the right editor.</li>
    </ol>
    <h2 className="text-xl font-semibold mt-6 mb-2">Example</h2>
    <div className="bg-gray-100 dark:bg-gray-800 rounded p-3 text-left text-sm mb-3 overflow-x-auto">
      <b>Input JSON:</b>
      <pre className="whitespace-pre-wrap">{`{
  "person": {
    "name": "John",
    "age": 30
  }
}`}</pre>
      <b>Output XML:</b>
      <pre className="whitespace-pre-wrap">{`<?xml version="1.0" encoding="UTF-8"?>
<person>
  <name>John</name>
  <age>30</age>
</person>`}</pre>
    </div>
    <p className="mt-4">Need help? See our <a href="/about" className="text-blue-600 underline">About</a> page or contact us for support.</p>
  </section>
  {/* AdSense Ad - Placed below converter */}
  <AdSenseAd adSlot="9698302360" />
</div>
  );
};

export default JsonToXml;
